export const Services = (props) => {
  return (
    <div id='services' className='text-center'>
      <div className='container'>
        <div className='section-title'>
          <h2>Our Services</h2>
          <p className="text-left">
          With broad expertise in web and app development, we develop and provide easy-to-use apps and web solutions for your company, brand, staff and customers. We are a responsive partner who helps you realize your digital strategy, with solutions at the technological forefront. Always with personal service and your business benefits in focus.
          </p>
        </div>
        <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className='col-lg-12'>
                  {' '}
                  {/* <i className={d.icon}></i> */}
                  <div className='service-desc'>
                    <h3 className="text-left">{d.name}</h3>
                    <p className="text-left" style={{fontSize:20}}>{d.text}</p>
                  </div>
                </div>
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  )
}
